import { type ReactElement } from "react";

import type { TrendPoint } from "../../api/types";
import { TabPanel } from "../Tabs";
import { TrendsChart } from "./TrendsChart";

// Trends tab: analytics only — the FaceAge-over-time chart. The series covers
// every estimated photo the participant ever submitted, including photos
// whose files were archived after the 7-day hot window (the backend keeps
// estimates forever), so this is the durable history view. Browsing photos
// lives on the Photos tab; the per-day diary lives in the Daily Log. This tab
// only renders for results-visible studies.
export function TrendsTab({ trends }: { trends: TrendPoint[] }): ReactElement {
  return (
    <TabPanel id="trends" title="Your FaceAge Trends">
      {trends.length === 0 ? (
        <p className="muted">No FaceAge results yet. Upload a photo in the Photos tab.</p>
      ) : (
        <TrendsChart points={trends} />
      )}
    </TabPanel>
  );
}
